export const AddNewRecipieInput = [
  {
    label: "Recipe Name",
    type: "text",
    id: "recipeName",
    valueKey: "recipeName",
    row: 1,
    disabled: true,
  },
  {
    label: "Plan Name",
    type: "text",
    id: "planName",
    valueKey: "planName",
    row: 1,
    disabled: true,
  },
  {
    label: "Description",
    type: "textarea",
    id: "description",
    valueKey: "description",
    rows: 4,
    row: 4,
    disabled: true,
  },
  {
    label: "Banner Image URL",
    type: "text",
    id: "bannerImageUrl",
    valueKey: "bannerImageUrl",
    row: 1,
    disabled: true,
  },
  {
    label: "Category", 
    type: "text", 
    id: "category", 
    valueKey: "category", 
    row: 1,
    disabled: true,
  },
  {
    label: "Recipe Keywords",
    type: "text",
    id: "recipeKeywords",
    valueKey: "recipeKeywords",
    row: 1,
    disabled: true,
  },
  {
    label: "Kcal",
    type: "text",
    id: "kcal",
    valueKey: "kcal",
    row: 1,
    disabled: true,
  },
  {
    label: "Serves",
    type: "text",
    id: "serves",
    valueKey: "serves",
    row: 1,
    disabled: true,
  },
  {
    label: "Carbs",
    type: "text",
    id: "carbs",
    valueKey: "carbs",
    row: 1,
    disabled: true,
  },
  {
    label: "Protein",
    type: "text",
    id: "protein",
    valueKey: "protein",
    row: 1,
    disabled: true,
  },
  {
    label: "Fat",
    type: "text",
    id: "fat",
    valueKey: "fat",
    row: 1,
    disabled: true,
  },
  {
    label: "Fibre",
    type: "text",
    id: "fibre",
    valueKey: "fibre",
    row: 1,
    disabled: true,
  },
  {
    label: "Instructions",
    type: "textarea",
    id: "instructions",
    valueKey: "instructions",
    rows: 6,
    row: 4,
    disabled: true,
  },
  {
    label: "Ingredients",
    type: "textarea",
    id: "ingredients",
    valueKey: "ingredients",
    rows: 6,
    row: 4,
    disabled: true,
  },
];
